module.exports = __webpack_public_path__ + "img/terms_cn.e229fca.jpg";